// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1KMQP","actions":"GroupTable_actions__2DRET","deleteModalFooter":"GroupTable_deleteModalFooter__UHC5l"};